import { useContext } from 'react'
import { IConfigObj, StoreContextType } from '@/context/types'

const Config = (context: React.Context<StoreContextType | null>) => {
  const store = useContext(context) as StoreContextType

  const getConfig = () => {
    return store.config.objConfig
  }
  const setConfig = (config: IConfigObj | null) => {
    store.config.setObjConfig(config)
  }

  return { getConfig, setConfig }
}

export default Config
